import React, { useEffect, useState } from "react";
import { Button, Col, DatePicker, Form, Input, Layout, Modal, Row } from "antd";
import "./inspection.css";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { auth, db } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import dayjs from "dayjs";
const { Header } = Layout;

const InspectionHeader = ({inspectionDetail,companyName}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
 
  const { id } = useParams();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const dateFormat = "YYYY-MM-DD";

  const onFinish = async (fieldsValue) => {
    const values = {
      ...fieldsValue,
      inspectionDate: fieldsValue["inspectionDate"]
        ? fieldsValue["inspectionDate"].format(dateFormat)
        : null,
    };

    const userRef = collection(db, "companies", companyName, "inspections");

    try {
      // Create a new collection named "inspections" under the "companyName" document
      const inspectionDocRef = doc(userRef, id);
      const inspectionDocSnapshot = await getDoc(inspectionDocRef);

      if (inspectionDocSnapshot.exists()) {
        // Update the inspection details
        await updateDoc(inspectionDocRef, {
          inspectionName: values.inspectionName || "",
          inspectionDate: values.inspectionDate || "",
          // Add other fields you want to update
        });
        toast.success("Inspection details updated successfully.");
        setIsModalOpen(false);
      } else {
        toast.error("No inspection found with the specified ID..");
      }
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const defaultValues = {
    inspectionName: inspectionDetail?.inspectionName, // Initial value for the Name field
    inspectionDate: inspectionDetail?.inspectionDate
      ? dayjs(inspectionDetail?.inspectionDate, dateFormat)
      : "", // Initial value for the Inspected On field (null if no initial date is required)
  };

  return (
    <div>
      <Header>
        <div className="inspection_topHeader" theme="dark">
          <h1>{inspectionDetail?.inspectionName}</h1>
          <div>
            <p>
              Inspection Date: {inspectionDetail?.inspectionDate}
              <span
                style={{ marginLeft: "10px", cursor: "pointer" }}
                onClick={showModal}
              >
                {" "}
                <i className="fa-solid fa-pen"></i>
              </span>
            </p>
          </div>
        </div>
      </Header>

      <Modal
        title="Edit Inspection"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        footer={<></>}
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          layout="vertical"
          initialValues={defaultValues} // Set the initial values
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label="Name"
            name="inspectionName"
            rules={[
              {
                required: true,
                message: "Please input inspection name!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Inspected On"
            name="inspectionDate"
            rules={[
              {
                required: true,
                message: "Please select inspection date!",
              },
            ]}
          >
            <DatePicker format={dateFormat} style={{ width: "100%" }} />
          </Form.Item>

          <Row gutter={16}>
            <Col>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
              </Form.Item>
            </Col>

            <Col>
              <Form.Item>
                <Button onClick={handleCancel}>Cancel</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default InspectionHeader;
